import styled from "styled-components";
import { fieldStyles, labelStyles } from "./ui";

const DOBBox = ({ name, setPayload, value }) => {
  let year = '';
  let month = '';
  let day = '';
  if(value){
    try {
      const dob = value.toDate();
      year = dob.getFullYear();
      month = dob.getMonth()+1;
      day = dob.getDate();
    } catch(e) {

    }
  }
  return (
    <Content role="group" aria-labelledby={ `${name}_title` }>
      <Title id={ `${name}_title` }>Date of Birth</Title>
      <Row>
      <Input 
        type="number"
        min="1"
        max="31"
        placeholder="DD"
        aria-label="Day"
        name="1"
        value={day}
        onChange= { e => { handleChange(e, name, setPayload) } }
      />
      <Input 
        type="number"
        min="1"
        max="12"
        placeholder="MM"
        aria-label="Month"
        name="0"
        value={month}
        onChange= { e => { handleChange(e, name, setPayload) } }
      />
      <Input
        type="number"
        min="1953"
        max="2003"
        placeholder="YYYY"
        aria-label="Year"
        name="2"
        value={year}
        onChange= { e => { handleChange(e, name, setPayload) } }
      />
      </Row>
    </Content>
  );
};

let DOB = []

const handleChange = (e, name, setPayload) => {
  DOB[e.target.name] = e.target.value;
  if (DOB.length === 3) {
    const dobDate = new Date(DOB.join("/"));
    setPayload(name, dobDate);
  }
}

const Content = styled.div`
  margin-bottom: 16px;
`;

const Title = styled.span`
  ${labelStyles}
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1.4fr;
  gap: 10px;
`;

const Input = styled.input`
  ${fieldStyles}
  text-align: center;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export default DOBBox;
